import { EmailService } from './../../core/services/email.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mailjet-index',
  templateUrl: './mailjet-index.component.html',
  styleUrls: ['./mailjet-index.component.scss']
})
export class MailjetIndexComponent implements OnInit {
  displayedColumns: string[] = [
    'bga',
    'name',
    'strasse',
    'plz',
    'ort',
  ];
  public totalCount = 0;

  public missingLoginsUsers = [];

  constructor(private emailService: EmailService) { }

  ngOnInit(): void {
    this.emailService.apothekenWithoutLogin().subscribe(res => {
      this.missingLoginsUsers = res as [];
    }, err => {
      console.log(err);
    });
  }

}
